import React from 'react';
import PropTypes from 'prop-types';

/**
 * This component displays '...' separator before last page number
 * @prop {boolean} isLast - whether current page is last page
 * @prop {number} page - current page number
 * @prop {string} separatorClassNames - class names to be applied to separator
 */
function LastPageSeparator({ isLast, page, separatorClassNames }) {
	if (isLast && page !== 1) {
		return <span className={separatorClassNames}>...</span>;
	}
}

LastPageSeparator.propTypes = {
	isLast: PropTypes.bool.isRequired,
	page: PropTypes.number.isRequired,
	separatorClassNames: PropTypes.string.isRequired,
};

export default LastPageSeparator;
